import twitter from "./images/twitter.png";
import weatherApp from "./images/weather-app.png";
import toursApp from "./images/tours-app.png";
import mernApp from "./images/MERN-app.jpg";
import routerMUI from "./images/quotes-app.png";
import authDemo from "./images/simple-firebase-auth-demo.png";
import airBnb from "./images/airbnb.jpg";
import huluImage from "./images/Hulu-demo-clone.png";

export const products = [
  {
    id: 1,
    img: twitter,
    link: "https://twitter-clone-thing.vercel.app/",
    desc: "Twitter Clone Thing",
    title: "Twitter Clone Thing",

    technologies: ["React", "TailWind"],
  },
  {
    id: 2,
    img: huluImage,
    link: "https://hulu-clone-demo.vercel.app/",
    desc: "Hulu Demo Clone",
    title: "Hulu Demo Clone",
    technologies: ["React", "TailWind"],
  },
  {
    id: 3,
    img: mernApp,
    link: "https://react-summary-core-2c1fb.web.app/",
    desc: "Fullstack MERN APP",
    title: "Fullstack MERN APP",
    technologies: ["React", "Express", "MongoDB", "NodeJS"],
  },
  {
    id: 4,
    img: airBnb,
    link: "https://airbnb-clone-thingy-demo.vercel.app/",
    desc: "Airbnb Clone Demo",
    title: "Airbnb Clone Demo",
    technologies: ["React", "TailWind"],
  },
  {
    id: 5,
    img: routerMUI,
    link: "https://react-router-demo-qu1gxl20g-zulaxy.vercel.app/quotes",
    desc: "Router - MUI - Lazy Load",
    title: "Router - MUI - Lazy Load",
    technologies: ["React", "Material UI"],
  },
  {
    id: 6,
    img: authDemo,
    link: "https://firebase-auth-demo-51fg.vercel.app/",
    desc: "Firebase Auth Demo",
    title: "Firebase Auth Demo",
    technologies: ["Firebase"],
  },
  {
    id: 7,
    img: undefined,
    link: "https://assignment-calendar-mu.vercel.app/",
    desc: "Google Calendar Copy",
    title: "Google Calendar Simple Clone",
    technologies: ["React", "Material UI, TypeScript", "Redux"],
  },
  {
    id: 8,
    img: undefined,
    link: "https://assignment-with-forms-and-testing.vercel.app/",
    desc: "Form with validation that does a post request to firebase in JSON",
    title: "Form for Sumitting Data",
    technologies: ["React", "Tailwind CSS"],
  },
  {
    id: 9,
    img: undefined,
    link: "https://menu-filter-categories.vercel.app/",
    desc: "Restaurant Menu with filters",
    title: "Restaurant Menu with filters",
    technologies: ["React"],
  },
  {
    id: 9,
    img: undefined,
    link: "https://mui-demo-app.vercel.app/",
    desc: "Material UI Demo Design",
    title: "Material UI Demo Design",
    technologies: ["React", "Material UI"],
  },
  {
    id: 10,
    img: undefined,
    link: "https://react-calculator-zulaxy.vercel.app/",
    desc: "React Calculator",
    title: "React Calculator",
    technologies: ["React", "Material UI"],
  },
];
